import { atom } from "recoil";

// KP全医療機関マスタのサイドバーにある投稿一覧用をページ数
export const infinitScrollPage = atom({
  key: "infinitScrollPage",
  default: 1,
});